import resolveFundraiser from "@dataResolvers/resolveFundraiser";
import queryCraftGQL from "../utils/queryCraftGQL";

const query = `
query MyQuery {
  entries(section:"fundraiser", site:"*",after:"2022-11-20") {
    ... on fundraiser_fundraiser_Entry {
      slug
      title
      goal
      heading0
      fName
      lName
      expDate
      backgroundImage0 {
        height
        url
        width
      }
    }
  }
}
`;

const getActions = async slug => {
  const variables = { slug };
  const { entries } = await queryCraftGQL({ query, variables });
  return entries.map(f => resolveFundraiser(f));
};

export default getActions;
